import PropTypes from "prop-types";
import {
  Box,
  FormControl,
  FormHelperText,
  FormLabel,
  MenuItem,
  Select,
} from "@material-ui/core";

export default function MonitoramentoPrecoCadastroSelect({
  label,
  value,
  onChange,
  options,
  required,
  disabled,
  error,
  helperText,
  emptyHint,
  emptyOptionLabel = "Selecione",
  classes,
}) {
  return (
    <Box>
      <FormLabel className={classes.cadastroFieldLabel} required={required}>
        {label}
      </FormLabel>
      <FormControl
        variant="outlined"
        margin="dense"
        fullWidth
        disabled={disabled}
        error={error}
        className={classes.cadastroSelectControl}
      >
        <Select
          displayEmpty
          value={value ?? ""}
          onChange={onChange}
          MenuProps={{
            disablePortal: true,
            getContentAnchorEl: null,
            anchorOrigin: { vertical: "bottom", horizontal: "left" },
            transformOrigin: { vertical: "top", horizontal: "left" },
          }}
          renderValue={(selected) => {
            if (!selected) {
              return (
                <span className={classes.cadastroSelectPlaceholder}>
                  {emptyOptionLabel}
                </span>
              );
            }
            const opt = options.find((o) => o.value === selected);
            return opt?.label ?? selected;
          }}
        >
          <MenuItem value="">
            <em>{emptyOptionLabel}</em>
          </MenuItem>
          {options.map((o) => (
            <MenuItem key={o.value} value={o.value}>
              {o.label}
            </MenuItem>
          ))}
        </Select>
        {helperText ? (
          <FormHelperText error={error}>{helperText}</FormHelperText>
        ) : null}
      </FormControl>
      {emptyHint ? (
        <FormHelperText error className={classes.cadastroSelectEmptyHint}>
          {emptyHint}
        </FormHelperText>
      ) : null}
    </Box>
  );
}

MonitoramentoPrecoCadastroSelect.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }),
  ).isRequired,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  helperText: PropTypes.string,
  emptyHint: PropTypes.string,
  emptyOptionLabel: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

MonitoramentoPrecoCadastroSelect.defaultProps = {
  value: "",
  required: false,
  disabled: false,
  error: false,
  helperText: "",
  emptyHint: "",
};
